/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Cloudflare_Email_TitleInputs */

const en_admin_settings_groups_cloudflare_email_title = /** @type {(inputs: Admin_Settings_Groups_Cloudflare_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Email`)
};

/**
* | output |
* | --- |
* | "Cloudflare Email" |
*
* @param {Admin_Settings_Groups_Cloudflare_Email_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_cloudflare_email_title = /** @type {((inputs?: Admin_Settings_Groups_Cloudflare_Email_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Cloudflare_Email_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_cloudflare_email_title(inputs)
});
export { admin_settings_groups_cloudflare_email_title as "admin.settings.groups.cloudflare_email.title" }